import { SmartTable } from '../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor(ShowNoteModal) {
        this.ShowNoteModal = ShowNoteModal;
    }

    $onInit() {
        this.st = new SmartTable();
    }

    showDescription(description){
		this.ShowNoteModal('company.software-license-management.description', description);
	}
}


// WEBPACK FOOTER //
// ./src/portal/states/company/software-license-management/list/software-license-management.list.controller.js